import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import RedirectToLowercase from './RedirectToLowercase';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Login = React.lazy(() => import('./views/login/login'));
const NovoCadastro = React.lazy(() => import('./views/login/novoCadastro'));

class App extends Component {
  constructor(props: any) {
    super(props);

    this.state = {
    };
  }

  render() {
    return (
      <HashRouter>
        <RedirectToLowercase>
          <Suspense fallback={loading}>
            <Switch>
              <Route path="/login" render={(props) => <Login {...props} />} />
              <Route path="/novocadastro" render={(props) => <NovoCadastro {...props} />} />
              <Route path="/" render={(props) => <TheLayout {...props} />} />
            </Switch>
          </Suspense>
        </RedirectToLowercase>
      </HashRouter>
    );
  }
}

export default App;